import {
    getList,
    getInformation,
    getSupporterList
} from "./api";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { SimpleCareRecipient } from "../../../domain/care_recipient/CareRecipient";


export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/CareRecipient",
    getList: "getList",
    getInfo: "getInfo",
    initSupporterList: "initSupporterList",
    getSupporterList: "getSupporterList",
    getSupporterListEachCareRecipientId: "getSupporterListEachCareRecipientId",
    selectCareRecipient: "selectCareRecipient",
    resetSelectedCareRecipient: "resetSelectedCareRecipient"
});

export const getListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getList}`,
    async(_, { rejectWithValue }) => {
        const response = await getList();

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const getInformationAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getInfo}`,
    async(careRecipientId: CareRecipientId, { rejectWithValue }) => {
        const response = await getInformation(careRecipientId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return {
                careRecipientInformation : { ...response }
            };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const initSupporterListAction = createAction(`${ActionType.base}/${ActionType.initSupporterList}`);

export const getSupporterListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getSupporterList}`,
    async(careRecipientId: CareRecipientId, { rejectWithValue }) => {
        const response = await getSupporterList(careRecipientId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return {
                supporters: {
                    careRecipientId: careRecipientId.value,
                    supporters: response.users
                }
            };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const selectCareRecipientAction = createAction(`${ActionType.base}/${ActionType.selectCareRecipient}`, function prepare(selectCareRecipient: SimpleCareRecipient) {
    return {
        payload: {
            id: selectCareRecipient.id.value,
            name: selectCareRecipient.name.value,
            houseId: selectCareRecipient.houseId?.value ?? null,
            customerCode: selectCareRecipient.customerCode?.value ?? null,
            branchCode: selectCareRecipient.branchCode?.value ?? null,
        }
    };
});

export const resetSelectedCareRecipientAction = createAction(`${ActionType.base}/${ActionType.resetSelectedCareRecipient}`);
